<template>
  <mi-dialog
    :model-value="modelValue"
    class="configuration-remove-all-choices-dialog"
    @update:model-value="emitUpdateModelValue"
  >
    <!-- Title -->
    <h5 class="q-mt-md q-mb-md"> Remove all choices? </h5>

    <!-- Subtitle -->
    <p class="q-mb-xl">
      This will remove all choices from all options selected in this list from the vehicle configuration.
    </p>

    <template #actions>
      <!-- Cancel button -->
      <mi-btn v-close-popup flat> Cancel </mi-btn>

      <!-- Submit button -->
      <mi-btn class="remove-all-btn" :loading="loading" @click="removeAllChoicesSelected"> Yes, remove all </mi-btn>
    </template>
  </mi-dialog>
</template>

<script>
  import { ref } from 'vue'

  export default {
    name: 'ConfigurationRemoveAllChoicesDialog',
    props: {
      modelValue: {
        type: Boolean,
        required: true
      },
      updateSelectedChoices: {
        type: Function,
        required: true
      }
    },
    emits: ['update:model-value'],
    setup(props, { emit }) {
      const loading = ref(false)

      const emitUpdateModelValue = (value = false) => {
        emit('update:model-value', value)
      }

      const removeAllChoicesSelected = async () => {
        loading.value = true
        await props.updateSelectedChoices([])
        loading.value = false
        emitUpdateModelValue()
      }

      return {
        removeAllChoicesSelected,
        emitUpdateModelValue,
        loading
      }
    }
  }
</script>

<style lang="scss">
  .configuration-remove-all-choices-dialog {
    .q-dialog__inner > .mi-card {
      width: 682px;
      max-width: 682px;
      min-width: 682px;
      height: 293px;
    }

    h5 {
      font-size: 28px;
    }

    .mi-btn {
      font-size: 18px;
      height: 50px;
    }

    .remove-all-btn {
      width: 167px;
    }

    .q-card__section:nth-child(2) {
      height: 160px;
    }
  }

  @media (max-width: $mi-responsive-large-width) {
    .configuration-remove-all-choices-dialog {
      .q-dialog__inner > .mi-card {
        width: 682px;
        max-width: 682px;
        height: 293px;
      }
    }
  }

  @media (max-width: $mi-responsive-medium-width) {
    .configuration-remove-all-choices-dialog {
      .q-dialog__inner > .mi-card {
        width: 682px;
        max-width: 682px;
        height: 293px;
      }
    }
  }
</style>
